export default "__VITE_ASSET__aAyGWsZM__"